<template>
  <div class="about">
    <transition name="fade">
      <img v-if="Richa" class="First" @click="clicked" src="../assets/richa.png" alt="">
    </transition>
    <transition name="slide-left">
      <img v-if="Hibr" @click="clickedH" class="hibr" src="../assets/7ibr.png" alt="">
    </transition>
    <transition name="slide-left">
      <img v-if="Reed" class="reed" src="../assets/reedimg.png" alt="">
    </transition>
    <transition name="zoom">
      <img v-if="AbouUS" class="Abou" src="../assets/AbouUs.png" alt="">
    </transition>
    <router-link to="/"><div class="Flip"></div></router-link>
    <router-link to="/project"><div class="FlipD"></div></router-link>
  </div>
</template>
<script>
import aboutus from '../assets/Artboard.png';


export default ({
  name:"About",
  components: {

  },
  data(){
    return{
      src:aboutus,
      AbouUS:false,
      Richa:true,
      Reed:false,
      Hibr:true,
    }
  },

  methods:{
    clicked(){
      this.Richa=false;
      this.AbouUS=true;
      console.log(this.Richa);
    },
    clickedH(){
      this.Reed=true;
      this.Hibr=false;
      console.log(this.Richa);
    }
  }
})
</script>

<style scoped>
/* Transition animations */
.fade-enter-active, .fade-leave-active {
  transition: all 0.6s ease;
}
.fade-enter-from {
  opacity: 0;
  transform: translateX(-50%) scale(0.8);
}
.fade-leave-to {
  opacity: 0;
  transform: translateX(-50%) scale(0.8);
}

.slide-left-enter-active, .slide-left-leave-active {
  transition: all 0.5s ease;
}
.slide-left-enter-from {
  opacity: 0;
  transform: translateX(100px);
}
.slide-left-leave-to {
  opacity: 0;
  transform: translateX(100px);
}

.zoom-enter-active {
  transition: all 0.8s cubic-bezier(0.68, -0.55, 0.265, 1.55);
  animation: typewriterReveal 3s steps(40) forwards;
}
.zoom-enter-from {
  opacity: 0;
  transform: scale(0);
}

/* Typewriter/Writing Animation */
@keyframes typewriterReveal {
  0% {
    clip-path: inset(0 100% 0 0);
    opacity: 0;
  }
  1% {
    opacity: 1;
  }
  100% {
    clip-path: inset(0 0 0 0);
    opacity: 1;
  }
}

@keyframes fadeInWords {
  0% {
    opacity: 0;
    filter: blur(8px);
  }
  100% {
    opacity: 1;
    filter: blur(0);
  }
}

.about {
  position: relative;
  width: 100%;
  min-height: 100vh;
}

.reed {
  position: absolute;
  z-index: 300;
  border-radius: 45px;
  top: 2%;
  left: 80%;
  margin: auto;
  width: 14%;
  max-width: 200px;
  min-width: 80px;
  mix-blend-mode: multiply;
  background: transparent;
}

.hibr {
  position: absolute;
  z-index: 300;
  top: 10%;
  left: 80%;
  margin: auto;
  width: 14%;
  max-width: 200px;
  min-width: 80px;
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.68, -0.55, 0.265, 1.55);
  touch-action: manipulation;
  filter: drop-shadow(0 4px 12px rgba(0, 0, 0, 0.3));
}

.hibr:hover,
.hibr:active {
  filter: brightness(1.25) drop-shadow(0 8px 20px rgba(255, 255, 255, 0.4));
  transform: scale(1.1) rotate(-5deg);
}

.Abou {
  position: absolute;
  z-index: -100;
  top: 0;
  left: 0;
  margin: auto;
  width: 100%;
  height: auto;
  animation: typewriterReveal 3.5s steps(50) forwards;
  clip-path: inset(0 100% 0 0);
}

.First {
  position: absolute;
  z-index: 100;
  top: 40%;
  left: 50%;
  transform: translateX(-50%);
  margin: auto;
  width: 30%;
  max-width: 400px;
  cursor: pointer;
  transition: all 0.5s cubic-bezier(0.68, -0.55, 0.265, 1.55);
  touch-action: manipulation;
  filter: drop-shadow(0 8px 20px rgba(0, 0, 0, 0.4));
}

div .Flip {
  position: fixed;
  background-image: url("../assets/layerFlip.png");
  background-repeat: no-repeat;
  background-size: contain;
  z-index: 200;
  width: 70px;
  height: 70px;
  left: 0%;
  top: 0%;
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.68, -0.55, 0.265, 1.55);
  touch-action: manipulation;
  filter: drop-shadow(0 2px 8px rgba(0, 0, 0, 0.3));
}

div .FlipD {
  position: fixed;
  background-image: url("../assets/FlipDown.png");
  background-repeat: no-repeat;
  background-size: contain;
  z-index: 300;
  width: 70px;
  height: 70px;
  right: 0%;
  bottom: 0%;
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.68, -0.55, 0.265, 1.55);
  touch-action: manipulation;
  filter: drop-shadow(0 2px 8px rgba(0, 0, 0, 0.3));
}

div .Flip:hover,
div .Flip:active {
  filter: brightness(1.3) drop-shadow(0 4px 16px rgba(255, 255, 255, 0.5));
  transform: scale(1.15) rotate(-10deg);
}

div .FlipD:hover,
div .FlipD:active {
  filter: brightness(1.3) drop-shadow(0 4px 16px rgba(255, 255, 255, 0.5));
  transform: scale(1.15) rotate(10deg);
}

.First:hover,
.First:active {
  filter: brightness(1.25) drop-shadow(0 12px 30px rgba(255, 255, 255, 0.5));
  transform: translateX(-50%) scale(1.18) rotate(2deg);
}

/* Tablet */
@media (max-width: 1024px) {
  .reed,
  .hibr {
    left: 75%;
    width: 18%;
  }
  
  .First {
    width: 40%;
    top: 35%;
  }
  
  .Flip,
  .FlipD {
    width: 60px;
    height: 60px;
  }
}

/* Mobile */
@media (max-width: 768px) {
  .reed {
    top: 60%;
    left: 50%;
    transform: translateX(-50%);
    width: 35%;
    max-width: 180px;
  }
  
  .hibr {
    top: 15%;
    left: 70%;
    width: 25%;
  }
  
  .First {
    width: 50%;
    top: 20%;
  }
  
  .Flip,
  .FlipD {
    width: 50px;
    height: 50px;
  }
}

@media (max-width: 480px) {
  .reed {
    top: 65%;
    left: 50%;
    transform: translateX(-50%);
    width: 40%;
    max-width: 150px;
    border-radius: 25px;
  }
  
  .hibr {
    top: 12%;
    left: 65%;
    width: 30%;
  }
  
  .First {
    width: 65%;
    top: 15%;
  }
  
  .Flip,
  .FlipD {
    width: 45px;
    height: 45px;
  }
  
  .First:hover,
  .First:active {
    transform: translateX(-50%) scale(1.1);
  }
}

/* Small mobile */
@media (max-width: 375px) {
  .reed {
    top: 68%;
    left: 50%;
    transform: translateX(-50%);
    width: 45%;
    max-width: 140px;
  }
  
  .hibr {
    left: 60%;
    width: 35%;
  }
  
  .First {
    width: 75%;
    top: 12%;
  }
}
</style>
